import LegacyMenu from './legacyMenu'

const Menu = {
  install(Vue) {
    Vue.prototype.$legacyMenus = function menus(data) {
      return data.map(menu => {
        const legacy = new LegacyMenu({
          menu_data: menu.published,
          menu_id: menu.id,
          tags_by_item_id: menu.tagsByItemId,
          price_multiplier: menu.pmult,
        })

        return Object.assign({}, menu, { legacy })
      })
    }
  }
}

export default Menu
